import React, { Component } from 'react';
import PropTypes from 'prop-types';

import '../ProductPackages/productPackages.styles.scss';

export default class MiniProductPackages extends Component {
    render() {
        const { productId, parts, showChildren } = this.props;

        if (!showChildren || parts.length === 0) {
            return null;
        }

        const partsList = [];

        for (const part of parts) {
            const partId = part.itemKey ? part.itemKey.itemNo : part.ItemNo.$;
            partsList.push(<li key={`mini-${productId}-${partId}`}>
                {partId.toString().match(/\d{1,3}/g).join('.')}
            </li>);
        }

        return (
            <ul className="product__packages-mini">
                {partsList}
            </ul>
        );
    }
}

MiniProductPackages.propTypes = {
    productId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
    parts: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.bool,
    ]).isRequired,
    showChildren: PropTypes.bool.isRequired,
};
